import * as React from "react";
import { observer } from "mobx-react";
import { computed } from "mobx";
import { Button } from "./Button";
import { DialogStore, DialogResult, DialogType } from "../Stores/DialogStore";
import { Strings } from "../Stores/StringsStore";

@observer
export class CancelButton extends Button {

	@computed get tooltip() {
		let tooltip = "";
		switch (DialogStore.dialogType) {
			case DialogType.Default:
				tooltip = Strings.general.no;
				break;
			case DialogType.DeleteConfirmation:
			case DialogType.Feedback:
				tooltip = Strings.general.cancel;
				break;
			case DialogType.None:
				tooltip = "";
				break;
		}
		return tooltip;
	}

	render() {
		return <Button {...this.props} title={this.props.title ? this.props.title : this.tooltip} >
			<i>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
					<path d="M16,0A16,16,0,1,0,32,16,16,16,0,0,0,16,0ZM3,16A13,13,0,0,1,24.06,5.82L5.82,24.06A12.93,12.93,0,0,1,3,16ZM16,29a12.93,12.93,0,0,1-8.06-2.82L26.18,7.94A13,13,0,0,1,16,29Z" />
				</svg>
			</i>
		</Button>;
	}
}
